// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  overflow-x: hidden;
}

#sidebar-wrapper {
  min-height: 100vh;
  margin-left: -15rem;
  transition: margin 0.25s ease-out;
}

#sidebar-wrapper .sidebar-heading {
  padding: 0.875rem 1.25rem;
  font-size: 1.2rem;
}

#sidebar-wrapper .list-group {
  width: 15rem;
}

#page-content-wrapper {
  min-width: 100vw;
}

#wrapper.toggled #sidebar-wrapper {
  margin-left: 0;
}
.navbar-expand-lg .navbar-toggler {
  display: block;
}
.btn-show {
  display: block;
}

.errorcount {
  font-size: 13px;
  position: relative;
  top: -18px;
  right: 9px;
}
.erroricon {
  font-size: 30px;
}

.modal-content {
  width: 1000px;
  left: -250px;
}

.tabname {
  font-weight: bold;
}
.addinfo {
  font-size: 0.8rem;
  min-width: 630px;
  max-height: 40px;
  position: absolute;
  overflow: overlay;
  align-items: center;
  margin: 4px;
}

@media (min-width: 768px) {
  #sidebar-wrapper {
    margin-left: 0;
  }

  #page-content-wrapper {
    min-width: 0;
    width: 100%;
  }

  #wrapper.toggled #sidebar-wrapper {
    margin-left: -15rem;
  }
  .addinfo {
    min-width: 200px;
    max-height: 30px;
  }
}

@media only screen and (min-width: 992px) {
  .btn-show {
    display: none !important;
  }
  .addinfo {
    min-width: 550px;
  }
}
/**header css starts**/

/**header css starts**/
.header {
  position: relative;
  width: 100%;
  height: 50px;
  background-color: #fff;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0;
  z-index: 103;
  box-shadow: 0 0.5rem 1rem 0 rgba(44, 51, 73, 0.1);
}
.header .logo {
  width: 125px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 50px;
}
.header .logo > img {
  width: 100%;
  height: auto;
}
.btnLeftNav {
  cursor: pointer;
  width: 50px;
  min-width: 50px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.8rem;
  position: relative;
  margin-right: 15px;
}
.btnLeftNav > i {
  position: relative;
}
.btnLeftNav > i,
.btnLeftNav > i:before,
.btnLeftNav > i:after {
  content: '';
  cursor: pointer;
  height: 2px;
  width: 22px;
  display: block;
  transition: background 0.1s ease-in-out, color 0.1s ease-in-out;
  background-color: #8f9bb3;
}
.btnLeftNav i:before {
  top: -6px;
  position: absolute;
}
.btnLeftNav i:after {
  bottom: -6px;
  position: absolute;
}
.btnLeftNav:hover i,
.btnLeftNav:hover i:before,
.btnLeftNav:hover i:after {
  background-color: #6f788c;
}
.header .link {
  text-transform: uppercase;
  vertical-align: middle;
}
.header .link > i {
  margin-right: 5px;
}
.header i.headerInfo {
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.85rem;
  margin-right: 5px;
}
.actionPgError {
  position: relative;
}
.header .profileInfo > a > span {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: inline-block;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #17a2b8;
  color: #fff;
  font-size: 1.2rem;
  font-weight: normal;
}
.header h1 {
  margin: 0 0 0 25px;
  position: relative;
  padding-left: 15px;
  color: #000;
  min-width: 250px;
}
.header h1::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  width: 1px;
  height: 100%;
  background-color: #edf1f7;
}

.additionalIconBtn {
  border-right: 1px solid #2baab9;
  padding: 4px 10px;
  line-height: 1;
  vertical-align: middle;
  cursor: pointer;
}

.additionalIconBtn > i {
  font-size: 1.42rem;
  line-height: 1;
}
.dropdownContainer .dropdown-toggle h6 {
  padding: 0px 7px;
}
@media only screen and (max-width: 760px) {
  .header .logo {
    display: none;
  }

  .header h1 {
    text-align: center;
    width: 75%;
    margin: 0;
    padding: 0;
  }
  .addinfo {
    min-width: 130px;
    max-height: 20px;
  }
}
/**header css ends**/

/* .header {
  position: relative;
  width: 100%;
  height: 70px;
  background-color: #2a62ff !important;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0;
  z-index: 103;
  box-shadow: 0 0.5rem 1rem 0 rgba(44, 51, 73, 0.1);
}
.header .logo {
  width: 180px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 50px;
  background-color: #fff;
}

.navImg {
  min-width: 250px;
  background-color: white;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media only screen and (max-width: 760px), (min-device-width: 768px) and (max-device-width: 1024px) {
  .navImg {
    min-width: 170px;
  }
}
.header .logo > img {
  width: 100%;
  height: auto;
}
.btnLeftNav {
  cursor: pointer;
  width: 50px;
  min-width: 50px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.8rem;
  position: relative;
}
.btnLeftNav > i {
  position: relative;
}
.btnLeftNav > i,
.btnLeftNav > i:before,
.btnLeftNav > i:after {
  content: '';
  cursor: pointer;
  height: 2px;
  width: 22px;
  display: block;
  transition: background 0.1s ease-in-out, color 0.1s ease-in-out;
  background-color: #fff;
}
.btnLeftNav i:before {
  top: -6px;
  position: absolute;
}
.btnLeftNav i:after {
  bottom: -6px;
  position: absolute;
}
.btnLeftNav:hover i,
.btnLeftNav:hover i:before,
.btnLeftNav:hover i:after {
  background-color: #6f788c;
}
.header .link {
  text-transform: uppercase;
  vertical-align: middle;
}
.header .link > i {
  margin-right: 5px;
}
.header i.headerInfo {
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.85rem;
  margin-right: 5px;
}
.actionPgError {
  position: relative;
}
.header .profileInfo > a > span {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: inline-block;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #17a2b8;
  color: #fff;
  font-size: 1.2rem;
  font-weight: normal;
}
.header h1 {
  position: relative;
  padding-left: 15px;
  color: #fff;
}

.additionalIconBtn {
  border-right: 1px solid #2baab9;
  padding: 4px 10px;
  line-height: 1;
  vertical-align: middle;
  cursor: pointer;
}

.additionalIconBtn > i {
  font-size: 1.42rem;
  line-height: 1;
}
.dropdownContainer .dropdown-toggle h6 {
  padding: 0px 7px;
}
@media only screen and (max-width: 760px) {
  .header .logo {
    display: none;
  }

  .header h1 {
    text-align: center;
    width: 75%;
    margin: 0;
    padding: 0;
  }
  .addinfo {
    min-width: 130px;
    max-height: 20px;
  }
} */
/**header css ends**/

.headerActions {
  display: flex;
  align-items: center;
  gap: 1rem;
  position: relative;
}

/* Notification Bell */
.notification-wrapper {
  position: relative;
  cursor: pointer;
}

.notification-wrapper i {
  font-size: 20px;
  color: gray;
}

.notification-badge {
  position: absolute;
  top: -5px;
  right: -3px;
  background: red;
  color: white;
  font-size: 10px;
  border-radius: 50%;
  padding: 2px 5px;
}

/* Profile */
.profile-wrapper {
  position: relative;
  cursor: pointer;
}

.profile-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid white;
}

/* .avatar-fallback {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid #36f;
  align-items: end;
  justify-content: center;
  display: flex;
} */
.profileContent {
  /* padding: 1.95rem 1rem 0.15rem; */
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgb(16, 4, 208);
  background: linear-gradient(
    90deg,
    rgba(16, 4, 208, 1) 0%,
    rgba(13, 113, 232, 1) 35%,
    rgba(67, 216, 246, 1) 100%
  );
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
}

.profile-dropdown {
  position: absolute;
  top: 40px;
  right: 0;
  background: #fff;
  border: 1px solid #ddd;
  list-style: none;
  padding: 5px 0;
  width: max-content;
  min-width: 165px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 999;
  max-width: 300px;
}

.profile-dropdown li {
  padding: 8px 12px;
  cursor: pointer;
}

.profile-dropdown li:hover {
  background-color: #f1f1f1;
}

/* Announcement Css starts here */

.announcement-ticker {
  display: flex;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  /* width: 60%; */
  width: 100%;
  color: #1f4c8c;
  font-weight: bold;
  font-size: 14px;
}

@media (min-width: 992px) {
  .announcement-ticker {
    min-width: 50px;
    max-width: 500px;
  }
}

.announcement-icon {
  margin-right: 8px;
  /* animation: blink 1s step-start infinite; */
  flex-shrink: 0;
  font-size: 25px;
}

.announcement-text-container {
  flex: 1;
  overflow: hidden;
}

.announcement-scroll {
  display: inline-block;
  white-space: nowrap;
  animation: scroll-left 50s linear infinite;
  font-size: 18px;
}

.announcement-scroll span {
  margin-right: 50px;
  display: inline-block;
}

@keyframes scroll-left {
  from {
    transform: translateX(0%);
  }
  to {
    transform: translateX(-100%);
  }
}

@keyframes blink {
  50% {
    opacity: 0;
  }
}

/* Announcement Css Ends here */
`, "",{"version":3,"sources":["webpack://./src/app/system-common/top-header/top-header.component.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EAInB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;AACA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,gBAAgB;EAClB;AACF;AACA,sBAAsB;;AAEtB,sBAAsB;AACtB;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,iDAAiD;AACnD;AACA;EACE,YAAY;EACZ,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;;;EAGE,WAAW;EACX,eAAe;EACf,WAAW;EACX,WAAW;EACX,cAAc;EACd,+DAA+D;EAC/D,yBAAyB;AAC3B;AACA;EACE,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;;;EAGE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,2BAA2B;EAC3B,UAAU;EACV,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,UAAU;EACZ;EACA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;AACF;AACA,oBAAoB;;AAEpB;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA6IG;AACH,oBAAoB;;AAEpB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;;;;;;;;GAQG;AACH;EACE,mCAAmC;EACnC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B;;;;;GAKC;EACD,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;EACzC,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iCAAiC;;AAEjC;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE,iBAAiB;EACjB,6CAA6C;EAC7C,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,0CAA0C;EAC1C,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA,+BAA+B","sourcesContent":["body {\n  overflow-x: hidden;\n}\n\n#sidebar-wrapper {\n  min-height: 100vh;\n  margin-left: -15rem;\n  -webkit-transition: margin 0.25s ease-out;\n  -moz-transition: margin 0.25s ease-out;\n  -o-transition: margin 0.25s ease-out;\n  transition: margin 0.25s ease-out;\n}\n\n#sidebar-wrapper .sidebar-heading {\n  padding: 0.875rem 1.25rem;\n  font-size: 1.2rem;\n}\n\n#sidebar-wrapper .list-group {\n  width: 15rem;\n}\n\n#page-content-wrapper {\n  min-width: 100vw;\n}\n\n#wrapper.toggled #sidebar-wrapper {\n  margin-left: 0;\n}\n.navbar-expand-lg .navbar-toggler {\n  display: block;\n}\n.btn-show {\n  display: block;\n}\n\n.errorcount {\n  font-size: 13px;\n  position: relative;\n  top: -18px;\n  right: 9px;\n}\n.erroricon {\n  font-size: 30px;\n}\n\n.modal-content {\n  width: 1000px;\n  left: -250px;\n}\n\n.tabname {\n  font-weight: bold;\n}\n.addinfo {\n  font-size: 0.8rem;\n  min-width: 630px;\n  max-height: 40px;\n  position: absolute;\n  overflow: overlay;\n  align-items: center;\n  margin: 4px;\n}\n\n@media (min-width: 768px) {\n  #sidebar-wrapper {\n    margin-left: 0;\n  }\n\n  #page-content-wrapper {\n    min-width: 0;\n    width: 100%;\n  }\n\n  #wrapper.toggled #sidebar-wrapper {\n    margin-left: -15rem;\n  }\n  .addinfo {\n    min-width: 200px;\n    max-height: 30px;\n  }\n}\n\n@media only screen and (min-width: 992px) {\n  .btn-show {\n    display: none !important;\n  }\n  .addinfo {\n    min-width: 550px;\n  }\n}\n/**header css starts**/\n\n/**header css starts**/\n.header {\n  position: relative;\n  width: 100%;\n  height: 50px;\n  background-color: #fff;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  padding: 0;\n  z-index: 103;\n  box-shadow: 0 0.5rem 1rem 0 rgba(44, 51, 73, 0.1);\n}\n.header .logo {\n  width: 125px;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  height: 50px;\n}\n.header .logo > img {\n  width: 100%;\n  height: auto;\n}\n.btnLeftNav {\n  cursor: pointer;\n  width: 50px;\n  min-width: 50px;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 1.8rem;\n  position: relative;\n  margin-right: 15px;\n}\n.btnLeftNav > i {\n  position: relative;\n}\n.btnLeftNav > i,\n.btnLeftNav > i:before,\n.btnLeftNav > i:after {\n  content: '';\n  cursor: pointer;\n  height: 2px;\n  width: 22px;\n  display: block;\n  transition: background 0.1s ease-in-out, color 0.1s ease-in-out;\n  background-color: #8f9bb3;\n}\n.btnLeftNav i:before {\n  top: -6px;\n  position: absolute;\n}\n.btnLeftNav i:after {\n  bottom: -6px;\n  position: absolute;\n}\n.btnLeftNav:hover i,\n.btnLeftNav:hover i:before,\n.btnLeftNav:hover i:after {\n  background-color: #6f788c;\n}\n.header .link {\n  text-transform: uppercase;\n  vertical-align: middle;\n}\n.header .link > i {\n  margin-right: 5px;\n}\n.header i.headerInfo {\n  color: rgba(255, 255, 255, 0.9);\n  font-size: 0.85rem;\n  margin-right: 5px;\n}\n.actionPgError {\n  position: relative;\n}\n.header .profileInfo > a > span {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: inline-block;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #17a2b8;\n  color: #fff;\n  font-size: 1.2rem;\n  font-weight: normal;\n}\n.header h1 {\n  margin: 0 0 0 25px;\n  position: relative;\n  padding-left: 15px;\n  color: #000;\n  min-width: 250px;\n}\n.header h1::before {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 0;\n  transform: translateY(-50%);\n  width: 1px;\n  height: 100%;\n  background-color: #edf1f7;\n}\n\n.additionalIconBtn {\n  border-right: 1px solid #2baab9;\n  padding: 4px 10px;\n  line-height: 1;\n  vertical-align: middle;\n  cursor: pointer;\n}\n\n.additionalIconBtn > i {\n  font-size: 1.42rem;\n  line-height: 1;\n}\n.dropdownContainer .dropdown-toggle h6 {\n  padding: 0px 7px;\n}\n@media only screen and (max-width: 760px) {\n  .header .logo {\n    display: none;\n  }\n\n  .header h1 {\n    text-align: center;\n    width: 75%;\n    margin: 0;\n    padding: 0;\n  }\n  .addinfo {\n    min-width: 130px;\n    max-height: 20px;\n  }\n}\n/**header css ends**/\n\n/* .header {\n  position: relative;\n  width: 100%;\n  height: 70px;\n  background-color: #2a62ff !important;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  padding: 0;\n  z-index: 103;\n  box-shadow: 0 0.5rem 1rem 0 rgba(44, 51, 73, 0.1);\n}\n.header .logo {\n  width: 180px;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  height: 50px;\n  background-color: #fff;\n}\n\n.navImg {\n  min-width: 250px;\n  background-color: white;\n  height: 70px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n@media only screen and (max-width: 760px), (min-device-width: 768px) and (max-device-width: 1024px) {\n  .navImg {\n    min-width: 170px;\n  }\n}\n.header .logo > img {\n  width: 100%;\n  height: auto;\n}\n.btnLeftNav {\n  cursor: pointer;\n  width: 50px;\n  min-width: 50px;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 1.8rem;\n  position: relative;\n}\n.btnLeftNav > i {\n  position: relative;\n}\n.btnLeftNav > i,\n.btnLeftNav > i:before,\n.btnLeftNav > i:after {\n  content: '';\n  cursor: pointer;\n  height: 2px;\n  width: 22px;\n  display: block;\n  transition: background 0.1s ease-in-out, color 0.1s ease-in-out;\n  background-color: #fff;\n}\n.btnLeftNav i:before {\n  top: -6px;\n  position: absolute;\n}\n.btnLeftNav i:after {\n  bottom: -6px;\n  position: absolute;\n}\n.btnLeftNav:hover i,\n.btnLeftNav:hover i:before,\n.btnLeftNav:hover i:after {\n  background-color: #6f788c;\n}\n.header .link {\n  text-transform: uppercase;\n  vertical-align: middle;\n}\n.header .link > i {\n  margin-right: 5px;\n}\n.header i.headerInfo {\n  color: rgba(255, 255, 255, 0.9);\n  font-size: 0.85rem;\n  margin-right: 5px;\n}\n.actionPgError {\n  position: relative;\n}\n.header .profileInfo > a > span {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: inline-block;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: #17a2b8;\n  color: #fff;\n  font-size: 1.2rem;\n  font-weight: normal;\n}\n.header h1 {\n  position: relative;\n  padding-left: 15px;\n  color: #fff;\n}\n\n.additionalIconBtn {\n  border-right: 1px solid #2baab9;\n  padding: 4px 10px;\n  line-height: 1;\n  vertical-align: middle;\n  cursor: pointer;\n}\n\n.additionalIconBtn > i {\n  font-size: 1.42rem;\n  line-height: 1;\n}\n.dropdownContainer .dropdown-toggle h6 {\n  padding: 0px 7px;\n}\n@media only screen and (max-width: 760px) {\n  .header .logo {\n    display: none;\n  }\n\n  .header h1 {\n    text-align: center;\n    width: 75%;\n    margin: 0;\n    padding: 0;\n  }\n  .addinfo {\n    min-width: 130px;\n    max-height: 20px;\n  }\n} */\n/**header css ends**/\n\n.headerActions {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  position: relative;\n}\n\n/* Notification Bell */\n.notification-wrapper {\n  position: relative;\n  cursor: pointer;\n}\n\n.notification-wrapper i {\n  font-size: 20px;\n  color: gray;\n}\n\n.notification-badge {\n  position: absolute;\n  top: -5px;\n  right: -3px;\n  background: red;\n  color: white;\n  font-size: 10px;\n  border-radius: 50%;\n  padding: 2px 5px;\n}\n\n/* Profile */\n.profile-wrapper {\n  position: relative;\n  cursor: pointer;\n}\n\n.profile-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  border: 1px solid white;\n}\n\n/* .avatar-fallback {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  border: 1px solid #36f;\n  align-items: end;\n  justify-content: center;\n  display: flex;\n} */\n.profileContent {\n  /* padding: 1.95rem 1rem 0.15rem; */\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: rgb(16, 4, 208);\n  background: linear-gradient(\n    90deg,\n    rgba(16, 4, 208, 1) 0%,\n    rgba(13, 113, 232, 1) 35%,\n    rgba(67, 216, 246, 1) 100%\n  );\n  color: #ffffff;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.profile-dropdown {\n  position: absolute;\n  top: 40px;\n  right: 0;\n  background: #fff;\n  border: 1px solid #ddd;\n  list-style: none;\n  padding: 5px 0;\n  width: max-content;\n  min-width: 165px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  z-index: 999;\n  max-width: 300px;\n}\n\n.profile-dropdown li {\n  padding: 8px 12px;\n  cursor: pointer;\n}\n\n.profile-dropdown li:hover {\n  background-color: #f1f1f1;\n}\n\n/* Announcement Css starts here */\n\n.announcement-ticker {\n  display: flex;\n  align-items: center;\n  white-space: nowrap;\n  overflow: hidden;\n  /* width: 60%; */\n  width: 100%;\n  color: #1f4c8c;\n  font-weight: bold;\n  font-size: 14px;\n}\n\n@media (min-width: 992px) {\n  .announcement-ticker {\n    min-width: 50px;\n    max-width: 500px;\n  }\n}\n\n.announcement-icon {\n  margin-right: 8px;\n  /* animation: blink 1s step-start infinite; */\n  flex-shrink: 0;\n  font-size: 25px;\n}\n\n.announcement-text-container {\n  flex: 1;\n  overflow: hidden;\n}\n\n.announcement-scroll {\n  display: inline-block;\n  white-space: nowrap;\n  animation: scroll-left 50s linear infinite;\n  font-size: 18px;\n}\n\n.announcement-scroll span {\n  margin-right: 50px;\n  display: inline-block;\n}\n\n@keyframes scroll-left {\n  from {\n    transform: translateX(0%);\n  }\n  to {\n    transform: translateX(-100%);\n  }\n}\n\n@keyframes blink {\n  50% {\n    opacity: 0;\n  }\n}\n\n/* Announcement Css Ends here */\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
